import React from 'react';
import { motion } from "framer-motion";
import { Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Service = ({ service }) => {
  const { id, name, price, img, description } = service;

  const navigate = useNavigate();
  const handleNavigateToServiceBooked = id => {
    navigate(`/service/${id}`);
  }
  
  return (
    <Col>
      <Card className='d-flex flex-nowrap flex-column flex-sm-row align-items-center justify-content-start'>
        <Card.Img variant="top" src={img} height='250vh' width='250vw' alt={name} className='rounded' />
        <Card.Body>
          <Card.Title>{name}</Card.Title>
          <Card.Text>{price}</Card.Text>
          <Card.Text style={{ textAlign: 'justify' }}>{description}</Card.Text>
          <motion.button whileHover={{ scale: 1.1}} whileTap={{ scale: 0.9 }} className='btn btn-outline-success' onClick={() => handleNavigateToServiceBooked(id)}>Checkout</motion.button>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default Service;